// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2Tsx from "./StatsTable2.tsx";
import IconButton from "@mui/material/IconButton";
import OpenInFull from "@mui/icons-material/OpenInFull";

var syncScroll = StatsTable2Tsx.syncScroll;

function col(defaultDescOpt, alignRightOpt, renderTitle, titleClass, renderValue, valueClass, tooltip, titleTooltip, order, rightBorderOpt, width, href, param) {
  var defaultDesc = defaultDescOpt !== undefined ? defaultDescOpt : true;
  var alignRight = alignRightOpt !== undefined ? alignRightOpt : false;
  var rightBorder = rightBorderOpt !== undefined ? rightBorderOpt : true;
  var widthClass = CssJs.style([CssJs.width({
              NAME: "px",
              VAL: width
            })]);
  return /* Col */{
          defaultDesc: defaultDesc,
          alignRight: alignRight,
          titleClass: Belt_Option.getWithDefault(titleClass, ""),
          renderTitle: renderTitle,
          valueClass: Belt_Option.getWithDefault(valueClass, ""),
          renderValue: renderValue,
          order: order,
          tooltip: tooltip,
          titleTooltip: titleTooltip,
          width: width,
          widthPct: undefined,
          widthClass: widthClass,
          rightBorder: rightBorder,
          href: href
        };
}

var make = StatsTable2Tsx.StatsTable;

function StatsTable2$ExpandIcon(Props) {
  var onClick = Props.onClick;
  return React.createElement("div", {
              className: "flex items-center h-full ml-[-6px] mr-[4px] sm:mr-[8px]"
            }, React.createElement(IconButton, {
                  classes: {
                    label: "text-[16px] sm:text-[18px] sm:ml-[2px]"
                  },
                  onClick: onClick,
                  size: "small",
                  children: React.createElement(OpenInFull, {
                        fontSize: "inherit"
                      })
                }));
}

var ExpandIcon = {
  make: StatsTable2$ExpandIcon
};

export {
  syncScroll ,
  col ,
  make ,
  ExpandIcon ,
  
}
/* syncScroll Not a pure module */
